<template>
  <div class="p-configurator" id="option">
    <side-banner :td_id="td_id.number" :car_id="carid.number" :p_url="p_url.p_url" />
    <confirm-reset />
    <the-title :title="title" />
    <step-menu @clickOptionTab="clickOptionTab" />
    <div>
      <div class="p-configurator__inner content">
        <div class="content__main_side">
          <nav class="inner_tab">
            <button
              v-if="existsMakerOption"
              @click="clickOptionTab('maker_options')"
              :class="[onVisibleOption === 'maker_options' ? 'active' : '']"
              class="reset"
            >
              メーカーオプション
            </button>
            <button
              @click="clickOptionTab('accessories')"
              :class="[onVisibleOption === 'accessories' ? 'active' : '']"
              class="reset"
            >
              アクセサリー
            </button>
            <button
              @click="clickOptionTab('services')"
              :class="[onVisibleOption === 'services' ? 'active' : '']"
              class="reset"
            >
              アフターサービス
            </button>
          </nav>
          <option-accessory
            v-if="onVisibleOption === 'maker_options'"
            :item_list="maker_options_list"
            :check_value="check_value"
            @click-Item="clickItemOption"
          />
          <option-accessory
            v-if="onVisibleOption === 'accessories'"
            :item_list="accessories_list"
            :check_value="check_value"
            @click-Item="clickItemOption"
          />
          <option-service
            v-if="onVisibleOption === 'services'"
            :item_list="services_list"
            :check_value="check_value"
            @click-Item="clickItemOption"
          />
        </div>
        <div class="summary_style">
          <summary-disp :isVisibleCarImage="true" :isChange="isChange" />
        </div>
      </div>
    </div>
    <bottom-banner :td_id="td_id.number" :car_id="carid.number" :p_url="p_url.p_url" />
  </div>
</template>

<script>
import { props, context, inject, reactive, ref } from "vue";
import RjConfiguration from "../functions/RjConfiguration";
import ConfirmReset from "../components/ConfirmReset.vue";
import TheTitle from "../components/Title.vue";
import StepMenu from "../components/StepMenu.vue";
import OptionAccessory from "../components/OptionAccessory.vue";
import OptionService from "../components/OptionService.vue";
import SummaryDisp from "../components/Summary.vue";
import SideBanner from "../components/SideBanner.vue";
import BottomBanner from "../components/BottomBanner.vue";

export default {
  components: {
    ConfirmReset,
    TheTitle,
    StepMenu,
    OptionAccessory,
    OptionService,
    SummaryDisp,
    SideBanner,
    BottomBanner,
  },
  setup(props, context) {
    const RJ = RjConfiguration();
    const title = RJ.getTitle();
    const item_car = RJ.getDataCar();
    let td_id = reactive({ number: item_car.testdrive_id });
    let carid = reactive({ number: item_car.catalog_id });
    let p_url = reactive({ p_url: item_car.purchase_url });

    const maker_options_list = RJ.getListMakerOptions();
    const accessories_list = RJ.getListAccessories();
    const services_list = RJ.getListServices();

    let onVisibleOption = ref(RJ.getOptionMode()); // メーカーオプション、アクセサリ、サービスプラン
    let check_value = reactive();
    check_value = RJ.getMyCheck();

    let isChange = reactive({ option: "aaa" });
    // 選択時処理
    const clickItemOption = (pMode, pGroup, pCode, pIndex) => {
      RJ.selectConfiguration(pGroup, pCode, pIndex);
      isChange.option = pMode + pGroup + pCode;
    };
    //Tabクリック処理
    const clickOptionTab = (pMode) => {
      onVisibleOption.value = pMode;
      RJ.setOptionMode(pMode);
    };
    const existsMakerOption = RJ.existsMakerOption();

    return {
      title,
      maker_options_list,
      accessories_list,
      services_list,
      clickItemOption,
      onVisibleOption,
      check_value,
      isChange,
      clickOptionTab,
      item_car,
      td_id,
      carid,
      p_url,
      existsMakerOption,
    };
  },
};
</script>

<style lang="scss" scoped>
.reset {
  color: #000;
}
</style>
